module.exports = __webpack_public_path__ + "static/media/school_mid.670df4fa.svg";